import { Injectable } from '@angular/core';
import { HttpClient, HttpContext } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { SPINNER } from 'src/app/modules/shared/tokens/http-context.tokens';

@Injectable({
  providedIn: 'root'
})
export class InventoryHotelsService {
  private _inventory_hotels = `${environment.inventory}/hotels`;

  constructor(
    private _http: HttpClient
  ) { }
  // get all the hotels 
  getAllHotels(pageNo: any, pageSize: any, searchKeyword: any, filters: any): Observable<any> {
    const paginationSettings = {
      pageNumber: pageNo || 1,
      pageSize: pageSize || 10,
      search: searchKeyword || "",
      filters: filters
    }
    return this._http.post<any>(`${this._inventory_hotels}`, paginationSettings);
  }

  // add hotel 
  AddInventoryHotel(formData: any): Observable<any> {
    return this._http.post<any>(`${this._inventory_hotels}/addhotel`, formData);
  }

  // get hotel
  getSpecificHotel(id: any): Observable<any> {
    return this._http.get<any>(`${this._inventory_hotels}/hotel/${id}`)
  }

  getPrepopulatedData(location: any, hotelName: any){
    return this._http.get<any>(`${this._inventory_hotels}/${location}/${hotelName}`, { context: new HttpContext().set(SPINNER, false)});
  }
  
  deleteHotel(id:any){
    return this._http.delete<any>(`${this._inventory_hotels}/hotel/${id}`);
  }

  performBulkActions(req:any): Observable<any>{
    return this._http.put<any>(`${environment.inventory}/updatehotels`, req)
  }
  
}
